export const theme = {
  colors: {
    black: '#000',
    white: '#fff',
    text: '#2a2a2a',
    backgroundWhite: '#fff',
    primary: '#07c',
    secondary: '#05a',
    accent: '#609',
    muted: '#f6f6f6',
    green: '#4caf50',
    red: '#f44336',
    blue: '#2196f3',
    backgroundLink: ' rgba(255,255,255,0.1)',
    primaryText: '#212121',
    secondaryText: '#757575',
    yellow: '#ffd617',
    link: '#AFB1B8',
    background: 'linear-gradient(90deg, #cce6ff,#7abfff,#52abff);',
    backgroundColor: '#F3F6F9',
    footerColor: '#212121',
  },
  space: [0, 2, 4, 8, 16, 44, 32, 30, 92, 64, 75, 128, 200, 256],
  fonts: {
    body: 'system-ui, sans-serif',
    heading: 'system-ui, sans-serif',
    monospace: 'Menlo, monospace',
  },
  fontSizes: {
    xs: '12px',
    s: '14px',
    m: '16px',
    ms: '18px',
    l: '32px',
    xl: '64px',
  },
  fontWeights: {
    normal: 400,
    bold: 700,
  },
  widths: {
    normal: '100%',
    max: '1440px',
  },
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  borders: {
    none: 'none',
    normal: '1px solid #5d5d5d',
    stand: '2px dashed black',
  },
  radii: {
    none: '0',
    normal: '4px',
    big: '10px',
    round: '50%',
  },
  primaryDark: '#0D0C1D',
  primaryLight: '#EFFFFA',
  primaryHover: '#343078',
  mobile: '576px',
};
